// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__5og8Y","tab":"Tabs_tab__1JarF","tabActive":"Tabs_tabActive__1VG4G"};